// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"86c12b10","6":"a576aa25","179":"5cf40707","220":"ef87d9eb","312":"6293d5c5","466":"0d617d44","537":"528cd8ec","562":"1b1d686d","746":"3b125dd8","769":"247a1f1f","784":"9a67183b","804":"73572dfd","885":"b6e83754","975":"9bce1001"}[chunkId] + ".chunk.js";
};